const experience = [
  {label: 'N/A', value: undefined},
  {label: 'Entry-level' , value: 'Entry-level (1-3 Years)'},
  {label: 'Mid-level', value: 'Mid-level (3-10 Years)'},
  {label: 'Senior-level', value: 'Senior-level (10+ Years)'}
];

export default experience;



// WEBPACK FOOTER //
// ./src/components/pages/KingstonConnect/Experience.js